// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__IcJMd","label":"Completed_label__1QXYc"};